import type { FC, PropsWithChildren } from 'react'
import type { CardProfileType } from '../atoms/CardProfile'
import { CardProfile } from '../atoms/CardProfile'
import ContentBlockWrapper from '../molecules/ContentBlockWrapper'

export type TeamBlockProps = {
	team: CardProfileType[]
}

export const TeamBlock: FC<PropsWithChildren<TeamBlockProps>> = ({ team }) => {
	return (
		<ContentBlockWrapper gridClassName="gap-y-2xl" layout="nested" blockTypes={['component']}>
			{team.map((profile, index) => (
				<div
					key={profile.name || index}
					className="col-span-2 tablet-p:col-span-4 tablet-l:col-span-3"
				>
					<CardProfile cardProfile={profile} />
				</div>
			))}
		</ContentBlockWrapper>
	)
}

export default TeamBlock
